import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthenticationStore } from '@/stores/authentication'

export function useShowLoadingScreen() {
  const authStore = useAuthenticationStore()
  const { hasInitialized } = storeToRefs(authStore)
  return computed(() => !hasInitialized.value)
}
